import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type Observation } from '../observations-table';

export interface ScansObservationSlideoverSignature {
  // The arguments accepted by the component
  Args: {
    observations: Observation[];
    initialIndex: number;
    onChange: (observation_id: string) => void;
    closeSlideover: () => void;
    isOpen: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ScansObservationSlideover extends Component<ScansObservationSlideoverSignature> {
  @tracked currentObservation: Observation | undefined;

  @tracked currentIndex: number = -1;

  get isOpen() {
    return this.args.isOpen;
  }

  get observation() {
    if (this.observations.length === 0) return undefined;
    return this.observations[this.currentIndex ?? 0];
  }

  get currentCount() {
    if (this.currentIndex === -1) return 0;
    return this.currentIndex + 1;
  }

  get totalObservationsCount() {
    return this.observations.length;
  }

  get observations() {
    return this.args.observations ?? [];
  }

  @action
  closeSlideover() {
    this.args.closeSlideover();
  }

  @action
  next() {
    const index = this.currentIndex;
    if (index === this.observations.length - 1) return;
    else if (index < 0 || index > this.totalObservationsCount - 1)
      throw new Error('Invalid index');
    else this.setIndex(index + 1);
  }

  @action
  previous() {
    const index = this.currentIndex;
    if (index === 0) return;
    else if (index < 0 || index > this.totalObservationsCount - 1)
      throw new Error('Invalid index');
    else this.setIndex(index - 1);
  }

  @action
  setIndex(index: number) {
    if (!isNaN(Number(index))) this.currentIndex = index;
  }

  @action
  propagateChange() {
    if (this.observation) this.args?.onChange?.(this.observation.id);
  }
}
